// extracted by mini-css-extract-plugin
export default {"filtersBox":"DtVXTV5d48ZzzEbmW6h8","userInfoBox":"Ilj2Z4zEu43gYHqnY_hs","inventoryInputsBox":"CeRm8FiFjgA65IucgMjJ"};